module.exports = __webpack_public_path__ + "static/media/tick-grey.7895e48b.svg";